import React from "react";
import classes from "./catIllustrations.module.css";

const CatIllustrations = () => {
  return (
    <div className={classes.illustrationsContainer}>
      <div className={classes.catItem}>
        <div className={classes.catImage}>
          {/* Fluffy white cat with blue eyes */}
          <svg viewBox="0 0 100 120" className={classes.catSvg}>
            {/* Background glow for visual interest */}
            <circle cx="50" cy="65" r="38" fill="#E6F7FF" opacity="0.5" />
            
            {/* Body */}
            <ellipse cx="50" cy="75" rx="28" ry="25" fill="#FFFFFF" stroke="#EEEEEE" strokeWidth="1" />
            
            {/* Fluffy fur details */}
            <path d="M22,75 Q25,65 22,55 Q30,58 35,55" fill="#FFFFFF" stroke="#EEEEEE" strokeWidth="0.5" />
            <path d="M78,75 Q75,65 78,55 Q70,58 65,55" fill="#FFFFFF" stroke="#EEEEEE" strokeWidth="0.5" />
            <path d="M30,100 Q40,105 50,102 Q60,105 70,100" fill="#FFFFFF" stroke="#EEEEEE" strokeWidth="0.5" />
            
            {/* Head */}
            <circle cx="50" cy="55" r="23" fill="#FFFFFF" />
            
            {/* Ears */}
            <polygon points="32,42 25,25 40,35" fill="#FFFFFF" stroke="#EEEEEE" strokeWidth="1" />
            <polygon points="68,42 75,25 60,35" fill="#FFFFFF" stroke="#EEEEEE" strokeWidth="1" />
            <polygon points="33,40 28,28 38,35" fill="#FFE6F2" stroke="#FFE6F2" strokeWidth="0.5" />
            <polygon points="67,40 72,28 62,35" fill="#FFE6F2" stroke="#FFE6F2" strokeWidth="0.5" />
            
            {/* Eyes - bright blue with highlights */}
            <ellipse cx="40" cy="58" rx="5" ry="6" fill="#4FC3F7" />
            <ellipse cx="60" cy="58" rx="5" ry="6" fill="#4FC3F7" />
            <ellipse cx="40" cy="58" rx="2" ry="3" fill="#000000" />
            <ellipse cx="60" cy="58" rx="2" ry="3" fill="#000000" />
            <circle cx="38" cy="56" r="1.5" fill="#FFFFFF" />
            <circle cx="58" cy="56" r="1.5" fill="#FFFFFF" />
            
            {/* Nose and mouth */}
            <polygon points="50,66 47,69 53,69" fill="#FFB6C1" />
            <path d="M50,69 L50,72 M50,72 Q47,76 44,75 M50,72 Q53,76 56,75" fill="none" stroke="#999999" strokeWidth="1" />
            
            {/* Whiskers */}
            <line x1="44" y1="69" x2="25" y2="66" stroke="#EEEEEE" strokeWidth="0.8" />
            <line x1="44" y1="70" x2="25" y2="70" stroke="#EEEEEE" strokeWidth="0.8" />
            <line x1="44" y1="71" x2="25" y2="74" stroke="#EEEEEE" strokeWidth="0.8" />
            <line x1="56" y1="69" x2="75" y2="66" stroke="#EEEEEE" strokeWidth="0.8" />
            <line x1="56" y1="70" x2="75" y2="70" stroke="#EEEEEE" strokeWidth="0.8" />
            <line x1="56" y1="71" x2="75" y2="74" stroke="#EEEEEE" strokeWidth="0.8" />
          </svg>
        </div>
        <div className={classes.catName}>
          <span className={classes.nameTag}>❄️ Crystal</span>
        </div>
      </div>

      <div className={classes.catItem}>
        <div className={classes.catImage}>
          {/* Orange tabby cat with green eyes */}
          <svg viewBox="0 0 100 120" className={classes.catSvg}>
            {/* Background for visual interest */}
            <circle cx="50" cy="65" r="38" fill="#FFF5E6" opacity="0.5" />
            
            {/* Body */}
            <ellipse cx="50" cy="75" rx="28" ry="25" fill="#FF9D42" stroke="#E68A38" strokeWidth="1" />
            
            {/* Tabby stripes on body */}
            <path d="M30,65 Q50,70 70,65" fill="none" stroke="#E68A38" strokeWidth="1.5" />
            <path d="M30,75 Q50,80 70,75" fill="none" stroke="#E68A38" strokeWidth="1.5" />
            <path d="M35,85 Q50,90 65,85" fill="none" stroke="#E68A38" strokeWidth="1.5" />
            <path d="M40,95 Q50,98 60,95" fill="none" stroke="#E68A38" strokeWidth="1.5" />
            
            {/* Head */}
            <circle cx="50" cy="55" r="23" fill="#FF9D42" />
            
            {/* Tabby markings on face */}
            <path d="M41,45 L47,50" stroke="#E68A38" strokeWidth="1.5" />
            <path d="M59,45 L53,50" stroke="#E68A38" strokeWidth="1.5" />
            <path d="M50,50 L50,65" stroke="#E68A38" strokeWidth="1.5" />
            
            {/* Ears */}
            <polygon points="32,42 25,25 40,35" fill="#FF9D42" stroke="#E68A38" strokeWidth="1" />
            <polygon points="68,42 75,25 60,35" fill="#FF9D42" stroke="#E68A38" strokeWidth="1" />
            <polygon points="33,40 28,28 38,35" fill="#E68A38" stroke="#E68A38" strokeWidth="0.5" />
            <polygon points="67,40 72,28 62,35" fill="#E68A38" stroke="#E68A38" strokeWidth="0.5" />
            
            {/* Eyes - bright green with highlights */}
            <ellipse cx="40" cy="58" rx="5" ry="6" fill="#4CAF50" />
            <ellipse cx="60" cy="58" rx="5" ry="6" fill="#4CAF50" />
            <ellipse cx="40" cy="58" rx="2" ry="3" fill="#000000" />
            <ellipse cx="60" cy="58" rx="2" ry="3" fill="#000000" />
            <circle cx="38" cy="56" r="1.5" fill="#FFFFFF" />
            <circle cx="58" cy="56" r="1.5" fill="#FFFFFF" />
            
            {/* Nose and mouth */}
            <polygon points="50,66 47,69 53,69" fill="#FFB6C1" />
            <path d="M50,69 L50,72 M50,72 Q47,76 44,75 M50,72 Q53,76 56,75" fill="none" stroke="#E68A38" strokeWidth="1" />
            
            {/* Whiskers */}
            <line x1="44" y1="69" x2="25" y2="66" stroke="#E68A38" strokeWidth="0.8" />
            <line x1="44" y1="70" x2="25" y2="70" stroke="#E68A38" strokeWidth="0.8" />
            <line x1="44" y1="71" x2="25" y2="74" stroke="#E68A38" strokeWidth="0.8" />
            <line x1="56" y1="69" x2="75" y2="66" stroke="#E68A38" strokeWidth="0.8" />
            <line x1="56" y1="70" x2="75" y2="70" stroke="#E68A38" strokeWidth="0.8" />
            <line x1="56" y1="71" x2="75" y2="74" stroke="#E68A38" strokeWidth="0.8" />
          </svg>
        </div>
        <div className={classes.catName}>
          <span className={classes.nameTag}>🔥 Tiger</span>
        </div>
      </div>

      <div className={classes.catItem}>
        <div className={classes.catImage}>
          {/* Tuxedo cat with yellow eyes */}
          <svg viewBox="0 0 100 120" className={classes.catSvg}>
            {/* Background for visual interest */}
            <circle cx="50" cy="65" r="38" fill="#F5F5F5" opacity="0.3" />
            
            {/* Body - black with white chest */}
            <ellipse cx="50" cy="75" rx="28" ry="25" fill="#000000" stroke="#222222" strokeWidth="1" />
            <path d="M38,62 Q50,95 62,62" fill="#FFFFFF" />
            
            {/* Head */}
            <circle cx="50" cy="55" r="23" fill="#000000" />
            
            {/* White face markings */}
            <path d="M40,55 Q50,80 60,55 Q60,45 50,40 Q40,45 40,55" fill="#FFFFFF" />
            
            {/* Ears */}
            <polygon points="32,42 25,25 40,35" fill="#000000" stroke="#222222" strokeWidth="1" />
            <polygon points="68,42 75,25 60,35" fill="#000000" stroke="#222222" strokeWidth="1" />
            <polygon points="33,40 28,28 38,35" fill="#444444" stroke="#444444" strokeWidth="0.5" />
            <polygon points="67,40 72,28 62,35" fill="#444444" stroke="#444444" strokeWidth="0.5" />
            
            {/* Eyes - amber/yellow with highlights */}
            <ellipse cx="40" cy="58" rx="5" ry="6" fill="#FFCA28" />
            <ellipse cx="60" cy="58" rx="5" ry="6" fill="#FFCA28" />
            <ellipse cx="40" cy="58" rx="2" ry="3" fill="#000000" />
            <ellipse cx="60" cy="58" rx="2" ry="3" fill="#000000" />
            <circle cx="38" cy="56" r="1.5" fill="#FFFFFF" />
            <circle cx="58" cy="56" r="1.5" fill="#FFFFFF" />
            
            {/* Nose and mouth */}
            <polygon points="50,66 47,69 53,69" fill="#FFB6C1" />
            <path d="M50,69 L50,72 M50,72 Q47,76 44,75 M50,72 Q53,76 56,75" fill="none" stroke="#555555" strokeWidth="1" />
            
            {/* Whiskers */}
            <line x1="44" y1="69" x2="25" y2="66" stroke="#FFFFFF" strokeWidth="0.8" />
            <line x1="44" y1="70" x2="25" y2="70" stroke="#FFFFFF" strokeWidth="0.8" />
            <line x1="44" y1="71" x2="25" y2="74" stroke="#FFFFFF" strokeWidth="0.8" />
            <line x1="56" y1="69" x2="75" y2="66" stroke="#FFFFFF" strokeWidth="0.8" />
            <line x1="56" y1="70" x2="75" y2="70" stroke="#FFFFFF" strokeWidth="0.8" />
            <line x1="56" y1="71" x2="75" y2="74" stroke="#FFFFFF" strokeWidth="0.8" />
          </svg>
        </div>
        <div className={classes.catName}>
          <span className={classes.nameTag}>✨ Felix</span>
        </div>
      </div>

      <div className={classes.catItem}>
        <div className={classes.catImage}>
          {/* Gray/silver cat with bright green eyes */}
          <svg viewBox="0 0 100 120" className={classes.catSvg}>
            {/* Background for visual interest */}
            <circle cx="50" cy="65" r="38" fill="#E6E6E6" opacity="0.5" />
            
            {/* Body with subtle gradient effect */}
            <ellipse cx="50" cy="75" rx="28" ry="25" fill="#A0A0A0" stroke="#888888" strokeWidth="1" />
            <ellipse cx="50" cy="75" rx="20" ry="18" fill="#B0B0B0" stroke="none" />
            
            {/* Head */}
            <circle cx="50" cy="55" r="23" fill="#A0A0A0" />
            <circle cx="50" cy="52" r="18" fill="#B0B0B0" />
            
            {/* Ears */}
            <polygon points="32,42 25,25 40,35" fill="#A0A0A0" stroke="#888888" strokeWidth="1" />
            <polygon points="68,42 75,25 60,35" fill="#A0A0A0" stroke="#888888" strokeWidth="1" />
            <polygon points="33,40 28,28 38,35" fill="#888888" stroke="#888888" strokeWidth="0.5" />
            <polygon points="67,40 72,28 62,35" fill="#888888" stroke="#888888" strokeWidth="0.5" />
            
            {/* Eyes - brilliant green with highlights */}
            <ellipse cx="40" cy="58" rx="5" ry="6" fill="#00C853" />
            <ellipse cx="60" cy="58" rx="5" ry="6" fill="#00C853" />
            <ellipse cx="40" cy="58" rx="2" ry="3" fill="#000000" />
            <ellipse cx="60" cy="58" rx="2" ry="3" fill="#000000" />
            <circle cx="38" cy="56" r="1.5" fill="#FFFFFF" />
            <circle cx="58" cy="56" r="1.5" fill="#FFFFFF" />
            
            {/* Nose and mouth */}
            <polygon points="50,66 47,69 53,69" fill="#FFB6C1" />
            <path d="M50,69 L50,72 M50,72 Q47,76 44,75 M50,72 Q53,76 56,75" fill="none" stroke="#777777" strokeWidth="1" />
            
            {/* Whiskers */}
            <line x1="44" y1="69" x2="25" y2="66" stroke="#DDDDDD" strokeWidth="0.8" />
            <line x1="44" y1="70" x2="25" y2="70" stroke="#DDDDDD" strokeWidth="0.8" />
            <line x1="44" y1="71" x2="25" y2="74" stroke="#DDDDDD" strokeWidth="0.8" />
            <line x1="56" y1="69" x2="75" y2="66" stroke="#DDDDDD" strokeWidth="0.8" />
            <line x1="56" y1="70" x2="75" y2="70" stroke="#DDDDDD" strokeWidth="0.8" />
            <line x1="56" y1="71" x2="75" y2="74" stroke="#DDDDDD" strokeWidth="0.8" />
          </svg>
        </div>
        <div className={classes.catName}>
          <span className={classes.nameTag}>🌙 Misty</span>
        </div>
      </div>

      <div className={classes.catItem}>
        <div className={classes.catImage}>
          {/* Calico cat */}
          <svg viewBox="0 0 100 120" className={classes.catSvg}>
            {/* Background for visual interest */}
            <circle cx="50" cy="65" r="38" fill="#FFF9E6" opacity="0.5" />
            
            {/* Body base */}
            <ellipse cx="50" cy="75" rx="28" ry="25" fill="#FFFFFF" stroke="#EEEEEE" strokeWidth="1" />
            
            {/* Calico patches */}
            <path d="M30,65 Q40,80 55,85 Q65,85 70,75" fill="#FF9D42" stroke="none" />
            <path d="M45,65 Q35,85 50,95 Q60,90 70,80" fill="#000000" stroke="none" />
            <circle cx="35" cy="75" r="8" fill="#000000" />
            <circle cx="60" cy="70" r="7" fill="#FF9D42" />
            
            {/* Head - white base */}
            <circle cx="50" cy="55" r="23" fill="#FFFFFF" />
            
            {/* Calico face markings */}
            <path d="M38,45 Q30,50 32,60 Q40,65 45,58" fill="#000000" />
            <path d="M62,45 Q72,50 68,60 Q62,65 55,58" fill="#FF9D42" />
            
            {/* Ears */}
            <polygon points="32,42 25,25 40,35" fill="#000000" stroke="#222222" strokeWidth="1" />
            <polygon points="68,42 75,25 60,35" fill="#FF9D42" stroke="#E68A38" strokeWidth="1" />
            <polygon points="33,40 28,28 38,35" fill="#222222" stroke="#222222" strokeWidth="0.5" />
            <polygon points="67,40 72,28 62,35" fill="#E68A38" stroke="#E68A38" strokeWidth="0.5" />
            
            {/* Eyes - green/amber mix with highlights */}
            <ellipse cx="40" cy="58" rx="5" ry="6" fill="#4CAF50" />
            <ellipse cx="60" cy="58" rx="5" ry="6" fill="#FFCA28" />
            <ellipse cx="40" cy="58" rx="2" ry="3" fill="#000000" />
            <ellipse cx="60" cy="58" rx="2" ry="3" fill="#000000" />
            <circle cx="38" cy="56" r="1.5" fill="#FFFFFF" />
            <circle cx="58" cy="56" r="1.5" fill="#FFFFFF" />
            
            {/* Nose and mouth */}
            <polygon points="50,66 47,69 53,69" fill="#FFB6C1" />
            <path d="M50,69 L50,72 M50,72 Q47,76 44,75 M50,72 Q53,76 56,75" fill="none" stroke="#777777" strokeWidth="1" />
            
            {/* Whiskers */}
            <line x1="44" y1="69" x2="25" y2="66" stroke="#EEEEEE" strokeWidth="0.8" />
            <line x1="44" y1="70" x2="25" y2="70" stroke="#EEEEEE" strokeWidth="0.8" />
            <line x1="44" y1="71" x2="25" y2="74" stroke="#EEEEEE" strokeWidth="0.8" />
            <line x1="56" y1="69" x2="75" y2="66" stroke="#EEEEEE" strokeWidth="0.8" />
            <line x1="56" y1="70" x2="75" y2="70" stroke="#EEEEEE" strokeWidth="0.8" />
            <line x1="56" y1="71" x2="75" y2="74" stroke="#EEEEEE" strokeWidth="0.8" />
          </svg>
        </div>
        <div className={classes.catName}>
          <span className={classes.nameTag}>🌈 Patches</span>
        </div>
      </div>

      <div className={classes.catItem}>
        <div className={classes.catImage}>
          {/* Siamese cat */}
          <svg viewBox="0 0 100 120" className={classes.catSvg}>
            {/* Background for visual interest */}
            <circle cx="50" cy="65" r="38" fill="#FFF5E6" opacity="0.5" />
            
            {/* Body - cream with darker points */}
            <ellipse cx="50" cy="75" rx="28" ry="25" fill="#F5E7C1" stroke="#E5D7B1" strokeWidth="1" />
            
            {/* Darker paws and tail */}
            <ellipse cx="32" cy="85" rx="7" ry="5" fill="#8B4513" />
            <ellipse cx="68" cy="85" rx="7" ry="5" fill="#8B4513" />
            <path d="M70,75 Q78,80 76,90" stroke="#8B4513" strokeWidth="8" fill="none" strokeLinecap="round" />
            
            {/* Head - cream colored */}
            <circle cx="50" cy="55" r="23" fill="#F5E7C1" />
            
            {/* Brown mask marking */}
            <path d="M35,45 Q50,75 65,45" fill="#8B4513" />
            
            {/* Ears */}
            <polygon points="32,42 25,25 40,35" fill="#8B4513" stroke="#6B3103" strokeWidth="1" />
            <polygon points="68,42 75,25 60,35" fill="#8B4513" stroke="#6B3103" strokeWidth="1" />
            <polygon points="33,40 28,28 38,35" fill="#6B3103" stroke="#6B3103" strokeWidth="0.5" />
            <polygon points="67,40 72,28 62,35" fill="#6B3103" stroke="#6B3103" strokeWidth="0.5" />
            
            {/* Eyes - bright blue with highlights */}
            <ellipse cx="40" cy="58" rx="5" ry="6" fill="#1E88E5" />
            <ellipse cx="60" cy="58" rx="5" ry="6" fill="#1E88E5" />
            <ellipse cx="40" cy="58" rx="2" ry="3" fill="#000000" />
            <ellipse cx="60" cy="58" rx="2" ry="3" fill="#000000" />
            <circle cx="38" cy="56" r="1.5" fill="#FFFFFF" />
            <circle cx="58" cy="56" r="1.5" fill="#FFFFFF" />
            
            {/* Nose and mouth */}
            <polygon points="50,66 47,69 53,69" fill="#FFB6C1" />
            <path d="M50,69 L50,72 M50,72 Q47,76 44,75 M50,72 Q53,76 56,75" fill="none" stroke="#6B3103" strokeWidth="1" />
            
            {/* Whiskers */}
            <line x1="44" y1="69" x2="25" y2="66" stroke="#E5D7B1" strokeWidth="0.8" />
            <line x1="44" y1="70" x2="25" y2="70" stroke="#E5D7B1" strokeWidth="0.8" />
            <line x1="44" y1="71" x2="25" y2="74" stroke="#E5D7B1" strokeWidth="0.8" />
            <line x1="56" y1="69" x2="75" y2="66" stroke="#E5D7B1" strokeWidth="0.8" />
            <line x1="56" y1="70" x2="75" y2="70" stroke="#E5D7B1" strokeWidth="0.8" />
            <line x1="56" y1="71" x2="75" y2="74" stroke="#E5D7B1" strokeWidth="0.8" />
          </svg>
        </div>
        <div className={classes.catName}>
          <span className={classes.nameTag}>💎 Siam</span>
        </div>
      </div>
    </div>
  );
};

export default CatIllustrations;